import { ExternalLink, Shield } from 'lucide-react'

/**
 * Outbound link to Helix Vault — external site, no data sync with Ovation.
 */
export function HelixVaultLink({ url, compact }: { url: string; compact?: boolean }) {
  if (compact) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 rounded-md border border-ovation-ink/10 bg-white px-3 py-2 text-sm font-medium text-ovation-ink hover:border-ovation-accent/40 hover:bg-ovation-paper"
      >
        <Shield className="h-4 w-4 text-ovation-accent" aria-hidden />
        <span>Helix Vault</span>
        <ExternalLink className="h-3.5 w-3.5 text-ovation-muted" aria-hidden />
      </a>
    )
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block rounded-lg border border-ovation-ink/10 bg-gradient-to-br from-ovation-ink to-ovation-ink/90 p-4 text-ovation-paper shadow-sm transition-opacity hover:opacity-95"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-ovation-paper/60">
            Geeky Bee ecosystem
          </p>
          <p className="mt-1 font-display text-xl">Helix Vault</p>
          <p className="mt-2 text-sm leading-relaxed text-ovation-paper/75">
            Artist assets and documents live in Helix — separate from Ovation tour ops. Opens in a
            new tab; nothing is synced between systems.
          </p>
        </div>
        <ExternalLink className="h-5 w-5 shrink-0 text-ovation-accent" aria-hidden />
      </div>
      <p className="mt-3 text-xs text-ovation-paper/50">Here is the vault →</p>
    </a>
  )
}
